import React from "react";

const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const KPI_CONFIG = [
  { key: "headcount",    label: "Headcount",         color: "#00ff90" },
  { key: "upcoming30",   label: "Appraisals (30d)",  color: "#fbbf24" },
  { key: "lastRaiseGt6m",label: "No raise (>6m)",    color: "#f87171" },
];

export default function SalaryFilters({ view, setView, filters, setFilters, kpis }) {
  const set = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  return (
    <div className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-5 space-y-4">

      {/* Tabs */}
      <div className="flex gap-2">
        {[
          { key: "team", label: "Team Salary"   },
          { key: "log",  label: "Increment Log" },
        ].map(t => (
          <button key={t.key} onClick={() => setView(t.key)}
            className={`text-xs px-4 py-2 rounded-full border transition-colors ${
              view === t.key
                ? "bg-[#00ff90]/15 border-[#00ff90]/40 text-[#00ff90]"
                : "bg-transparent border-white/10 text-white/40 hover:border-[#00ff90]/20 hover:text-white/60"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        <div className="md:col-span-2">
          <label className={labelCls}>Search</label>
          <input className={inputCls} placeholder="Name or role…" value={filters.search}
            onChange={e => set("search", e.target.value)} />
        </div>
        {view === "log" && (
          <>
            <div>
              <label className={labelCls}>From</label>
              <input type="date" className={inputCls} value={filters.from} onChange={e => set("from", e.target.value)} />
            </div>
            <div>
              <label className={labelCls}>To</label>
              <input type="date" className={inputCls} value={filters.to} onChange={e => set("to", e.target.value)} />
            </div>
          </>
        )}
      </div>

      {/* KPIs */}
      {kpis && view === "team" && (
        <div className="grid grid-cols-3 gap-3 pt-1 border-t border-white/5">
          {KPI_CONFIG.map(({ key, label, color }) => (
            <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
              <p className="text-lg font-bold" style={{ color }}>{kpis[key] ?? 0}</p>
              <p className="text-xs text-white/30 mt-0.5">{label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}